import React, { Component } from 'react';

const CartLineItem = ({ product, API }) => {
  return (
    <div className="Card Card--product">
      <button className="Button delete-line" data-layout="noLayout" onClick={() => API.updateLineItemQty(product.variant_id, 0)} aria-label="remove">
        <svg viewBox="0 0 20 20" className="icon" width="1em" height="1em">
          <use xlinkHref="#close"></use>
        </svg>
      </button>
      <figure className="Card__figure">
        <a href={product.url}>
          {product.image && 
            <img src={product.image} alt={product.product_title} />
          }
        </a>
      </figure>
      <div className="Card__details">
        <h6 className="Card__title">
          <a href={product.url}>
            {product.product_title} {product.variant_title && <small>{product.variant_title}</small>}
          </a>
        </h6>
        <div className="quantity_and_amount">
          <div className="quantity"><span className="value">QTY: {product.quantity}</span></div>
          <div className="amount">${(product.line_price / 100).toFixed(2)}</div>
          {/* <div className="quantity">
            <button onClick={() => API.updateLineItemQty(product.variant_id, product.quantity - 1)}>-</button>
            <span className="value">{product.quantity}</span>
            <button onClick={() => API.updateLineItemQty(product.variant_id, product.quantity + 1)}>+</button>
          </div> */}
        </div>
        
      </div>
    </div>
  );
};

class CartLineItem1 extends Component {
  increaseQuantity = () => {
    // this.props.updateLineQuantity(this.props.product.variant_id, this.props.product.quantity + 1);
  };

  decreaseQuantity = () => {
    // this.props.updateLineQuantity(this.props.product.variant_id, this.props.product.quantity - 1);
  };

  removeProduct = () => {
    this.props.updateLineQuantity(this.props.product.variant_id, 0);
  };

  render() {
    const product = this.props.product;
  }
}

export default CartLineItem;
